module.exports = __webpack_public_path__ + "static/img/1.ff8e02f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/1.png
// module id = HvyA
// module chunks = 0